import { COLOUR } from '../../../utils/constants';

export default {
  popup: {
    background: COLOUR.MEDIUM_GREY,
    border: '1px solid white'
  }
};